import { FormHelperText, styled } from '@mui/material'

// TODO: Apply design library styling
const HelpText = styled(FormHelperText)(() => ({}))

export default HelpText
